import 'react-dates/initialize'
import React from 'react'
import Routes from './routes'

import 'unfetch/polyfill'
import 'antd/dist/antd.css';
import './styles/main.scss'
import 'react-table/react-table.css'
import 'react-tippy/dist/tippy.css'
import 'react-datepicker/dist/react-datepicker.css'
import 'react-dates/lib/css/_datepicker.css'
import './styles/react-dates-overrides.css'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import './styles/toggle.css'

const renderApp = async (Component) => {
  const { render } = await import(/* webpackChunkName: "render" */ 'react-dom');
  render(<Component />, document.getElementById('app'));
}

renderApp(Routes)
